import { Component } from '@angular/core';
import { CoreSignalProfileEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Profiles') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalprofile-form',
    templateUrl: './coresignalprofile.form.component.html'
})
export class CoreSignalProfileFormComponent extends BaseFormComponent {
    public record!: CoreSignalProfileEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'certifications', sectionName: 'Certifications', isExpanded: false },
            { sectionKey: 'awards', sectionName: 'Awards', isExpanded: false },
            { sectionKey: 'experiences', sectionName: 'Experiences', isExpanded: false },
            { sectionKey: 'educationsCoreSignal', sectionName: 'Educations__CoreSignal', isExpanded: false },
            { sectionKey: 'profileMatches', sectionName: 'Profile Matches', isExpanded: false },
            { sectionKey: 'publications', sectionName: 'Publications', isExpanded: false },
            { sectionKey: 'languages', sectionName: 'Languages', isExpanded: false },
            { sectionKey: 'patents', sectionName: 'Patents', isExpanded: false },
            { sectionKey: 'skills', sectionName: 'Skills', isExpanded: false },
            { sectionKey: 'projects', sectionName: 'Projects', isExpanded: false },
            { sectionKey: 'courses', sectionName: 'Courses', isExpanded: false },
            { sectionKey: 'memberOrganizations', sectionName: 'Member Organizations', isExpanded: false }
        ]);
    }
}

